"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const paramKeys_1 = require("../paramKeys");
const sendHit = (tracker) => {
    const hitType = tracker.params.get(paramKeys_1.default.HitType) || '';
    const payload = tracker.params.get(paramKeys_1.default.HitPayload) || {};
    tracker.postData(hitType, payload);
};
exports.default = sendHit;
